export default __webpack_public_path__ + "static/magic-pen-a4862d41c4c21bb88b79a631e1f17f64.png";